module.exports = new __parcel__URL__("../marker-icon-2x-blue.67802419.png").toString();